// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Hooks = require("../../../utils/Hooks.bs.js");
var Utils = require("../../../utils/Utils.bs.js");
var React = require("react");
var Scroll = require("../../../reason/common/Scroll/Scroll.bs.js");
var Scalars = require("../../../scalars/Scalars.bs.js");
var UTCDate = require("../../../reason/common/types/UTCDate.bs.js");
var DateFns = require("date-fns");
var ButtonsV5 = require("../../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
var Icon__Jsx3 = require("../../../uikit/reason/atoms/Icon/Icon__Jsx3.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Core__Array = require("@rescript/core/src/Core__Array.bs.js");
var RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");
var GraphQLWSClient = require("../../../GraphQLWSClient.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var RescriptRelay_Mutation = require("rescript-relay/src/RescriptRelay_Mutation.bs.js");
var RescriptRelay_Subscriptions = require("rescript-relay/src/RescriptRelay_Subscriptions.bs.js");
var ConversationPageConversationMessagesMessage = require("./ConversationPageConversationMessagesMessage.bs.js");
var ConversationPageConversationMessagesRefetchQuery_graphql = require("../../../__generated__/ConversationPageConversationMessagesRefetchQuery_graphql.bs.js");
var ConversationPageConversationMessages_conversation_graphql = require("../../../__generated__/ConversationPageConversationMessages_conversation_graphql.bs.js");
var ConversationPageConversationMessages_ConversationEventsSubscription_graphql = require("../../../__generated__/ConversationPageConversationMessages_ConversationEventsSubscription_graphql.bs.js");
var ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql = require("../../../__generated__/ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.bs.js");

function ConversationPageConversationMessages$MessagesContainer(props) {
  return JsxRuntime.jsx("div", {
              children: props.children,
              ref: props.forwardRef,
              className: "h-auto max-h-[519px] overflow-auto px-2"
            });
}

var MessagesContainer = {
  make: ConversationPageConversationMessages$MessagesContainer
};

var getConnectionNodes = ConversationPageConversationMessages_conversation_graphql.Utils.getConnectionNodes;

var convertFragment = ConversationPageConversationMessages_conversation_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ConversationPageConversationMessages_conversation_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ConversationPageConversationMessages_conversation_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, ConversationPageConversationMessages_conversation_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ConversationPageConversationMessages_conversation_graphql.node, convertFragment, fRef);
}

var makeRefetchVariables = ConversationPageConversationMessagesRefetchQuery_graphql.Types.makeRefetchVariables;

var convertRefetchVariables = ConversationPageConversationMessagesRefetchQuery_graphql.Internal.convertVariables;

function useRefetchable(fRef) {
  return RescriptRelay_Fragment.useRefetchableFragment(ConversationPageConversationMessages_conversation_graphql.node, convertFragment, convertRefetchVariables, fRef);
}

function usePagination(fRef) {
  return RescriptRelay_Fragment.usePaginationFragment(ConversationPageConversationMessages_conversation_graphql.node, fRef, convertFragment, convertRefetchVariables);
}

var ConversationFragment_incomingMessageStatusState_decode = ConversationPageConversationMessages_conversation_graphql.Utils.incomingMessageStatusState_decode;

var ConversationFragment_incomingMessageStatusState_fromString = ConversationPageConversationMessages_conversation_graphql.Utils.incomingMessageStatusState_fromString;

var ConversationFragment = {
  getConnectionNodes: getConnectionNodes,
  incomingMessageStatusState_decode: ConversationFragment_incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: ConversationFragment_incomingMessageStatusState_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment,
  makeRefetchVariables: makeRefetchVariables,
  convertRefetchVariables: convertRefetchVariables,
  useRefetchable: useRefetchable,
  usePagination: usePagination
};

var convertVariables = ConversationPageConversationMessages_ConversationEventsSubscription_graphql.Internal.convertVariables;

var convertResponse = ConversationPageConversationMessages_ConversationEventsSubscription_graphql.Internal.convertResponse;

var subscribe = RescriptRelay_Subscriptions.subscribe(ConversationPageConversationMessages_ConversationEventsSubscription_graphql.node, convertVariables, convertResponse);

var Subscription = {
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables,
  convertResponse: convertResponse,
  subscribe: subscribe
};

function ConversationPageConversationMessages$ContextEventMessage(props) {
  var link = props.link;
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(Icon__Jsx3.make, {
                            icon: "MegaphoneAlt",
                            size: 30
                          }),
                      className: "mr-2.5"
                    }),
                JsxRuntime.jsxs("div", {
                      children: [
                        props.text,
                        link !== undefined ? JsxRuntime.jsx("div", {
                                children: JsxRuntime.jsx(ButtonsV5.Link.make, {
                                      href: link.href,
                                      className: "underline text-gray-700",
                                      children: Caml_option.some(link.text)
                                    }),
                                className: "mt-4"
                              }) : null
                      ],
                      className: "bg-gray-100 border px-4 py-2 rounded-sm"
                    })
              ],
              className: "flex flex-row space-x-2"
            });
}

var ContextEventMessage = {
  make: ConversationPageConversationMessages$ContextEventMessage
};

var convertVariables$1 = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Internal.convertVariables;

var convertResponse$1 = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Internal.convertResponse;

var convertWrapRawResponse = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Internal.convertWrapRawResponse;

var commitMutation = RescriptRelay_Mutation.commitMutation(convertVariables$1, ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse);

var use$1 = RescriptRelay_Mutation.useMutation(convertVariables$1, ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.node, convertResponse$1, convertWrapRawResponse);

var MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_decode = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Utils.incomingMessageStatusState_decode;

var MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_fromString = ConversationPageConversationMessages_MarkConversationMessagesAsReadV5Mutation_graphql.Utils.incomingMessageStatusState_fromString;

var MarkConversationMessagesAsReadV5Mutation = {
  incomingMessageStatusState_decode: MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_decode,
  incomingMessageStatusState_fromString: MarkConversationMessagesAsReadV5Mutation_incomingMessageStatusState_fromString,
  Operation: undefined,
  Types: undefined,
  convertVariables: convertVariables$1,
  convertResponse: convertResponse$1,
  convertWrapRawResponse: convertWrapRawResponse,
  commitMutation: commitMutation,
  use: use$1
};

function ConversationPageConversationMessages(props) {
  var match = useRefetchable(props.conversation);
  var refetch = match[1];
  var conversation = match[0];
  var match$1 = use$1();
  var markAsRead = match$1[0];
  var match$2 = React.useTransition();
  var startTransition = match$2[1];
  var environment = RescriptRelay.useEnvironmentFromContext();
  var messages = getConnectionNodes(conversation.conversationTimeline);
  var unreadMessages = messages.filter(function (m) {
        if (m.__typename !== "ConversationMessageV5") {
          return false;
        }
        var match = m.status;
        if (match === undefined) {
          return false;
        }
        if (match.__typename !== "IncomingMessageStatus") {
          return false;
        }
        var tmp = match.state;
        if ((tmp === "PAST_MESSAGE" || tmp === "NEW" || tmp === "READ") && tmp === "NEW") {
          return true;
        } else {
          return false;
        }
      });
  var messagesReadElementRef = React.useRef(undefined);
  var messagesListRef = React.useRef(undefined);
  var scrollMessagesToBottom = function () {
    var current = messagesListRef.current;
    if (current === undefined) {
      return ;
    }
    var current$1 = Caml_option.valFromOption(current);
    current$1.scrollTop = current$1.scrollHeight;
  };
  var markAsReadDispatchedAt = React.useRef(undefined);
  var markAsRead$1 = function () {
    var match = markAsReadDispatchedAt.current;
    var match$1 = messagesReadElementRef.current;
    var match$2 = Core__Array.filterMap(messages, (function (m) {
              if (m.__typename === "ConversationMessageV5") {
                return m.id;
              }
              
            }))[messages.length - 1 | 0];
    if (match !== undefined) {
      return ;
    }
    if (match$1 === undefined) {
      return ;
    }
    if (match$2 === undefined) {
      return ;
    }
    if (!(Scroll.isElementInView(Caml_option.valFromOption(match$1)) && unreadMessages.length > 0)) {
      return ;
    }
    markAsReadDispatchedAt.current = Date.now();
    var unmarkAsDispatched = function () {
      var match = markAsReadDispatchedAt.current;
      if (match !== undefined) {
        markAsReadDispatchedAt.current = undefined;
        return ;
      }
      
    };
    markAsRead({
          input: {
            conversationId: conversation.id,
            lastReadMessageId: match$2
          }
        }, undefined, undefined, undefined, (function (param, param$1) {
            unmarkAsDispatched();
          }), (function (param) {
            unmarkAsDispatched();
          }), undefined);
  };
  Hooks.useEventListenerOnDocument(true, (function (param) {
          markAsRead$1();
        }), "scroll");
  React.useLayoutEffect((function () {
          scrollMessagesToBottom();
        }), [conversation]);
  React.useEffect((function () {
          markAsRead$1();
        }), [conversation]);
  React.useEffect((function () {
          var subscription = subscribe(environment, {
                connections: [ConversationPageConversationMessages_conversation_graphql.makeConnectionId(conversation.__id)],
                conversationId: conversation.id
              }, undefined, undefined, undefined, undefined);
          return (function () {
                    subscription.dispose();
                  });
        }), [
        conversation.id,
        conversation.__id
      ]);
  var refetchMessages = React.useCallback((function () {
          startTransition(function () {
                refetch(makeRefetchVariables(undefined, undefined, conversation.nodeId), "network-only", undefined);
              });
        }), [
        refetch,
        startTransition,
        conversation.nodeId
      ]);
  var wsIsClosed = React.useRef(false);
  var onWsStatusUpdated = React.useCallback((function (status) {
          var match = wsIsClosed.current;
          switch (status) {
            case "Closed" :
                wsIsClosed.current = true;
                return ;
            case "Connecting" :
                return ;
            case "Connected" :
                if (match) {
                  refetchMessages();
                  wsIsClosed.current = false;
                  return ;
                } else {
                  return ;
                }
            
          }
        }), [refetchMessages]);
  GraphQLWSClient.useOnWsStatusUpdated(onWsStatusUpdated);
  var lastPrintedDay = {
    contents: undefined
  };
  var today = DateFns.format(new Date(), "MM/dd/yyyy");
  return JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                JsxRuntime.jsx(ConversationPageConversationMessages$MessagesContainer, {
                      children: messages.map(function (item) {
                            var dateForItem;
                            switch (item.__typename) {
                              case "ConversationMessageV5" :
                                  dateForItem = item.sentAt;
                                  break;
                              case "__unselected" :
                                  dateForItem = undefined;
                                  break;
                              default:
                                dateForItem = item.broadcastAt;
                            }
                            var key;
                            switch (item.__typename) {
                              case "ConversationMessageV5" :
                                  key = item.id;
                                  break;
                              case "__unselected" :
                                  key = "";
                                  break;
                              default:
                                key = item.id;
                            }
                            var dayForItem = DateFns.format(dateForItem !== undefined ? UTCDate.toUnzonedDate(Scalars.DateTime.toUTC(Caml_option.valFromOption(dateForItem))) : new Date(), "MM/dd/yyyy");
                            var tmp;
                            switch (item.__typename) {
                              case "BuyerNeedBroadcast" :
                                  var content = item.content;
                                  var tmp$1;
                                  tmp$1 = content !== undefined && content.__typename === "BuyerNeedV5" ? ({
                                        text: "Click here to view the buyer need page",
                                        href: "/client_needs/" + content.id
                                      }) : undefined;
                                  tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                                        text: "The buyer need was broadcast",
                                        link: tmp$1
                                      });
                                  break;
                              case "ConversationMessageV5" :
                                  tmp = JsxRuntime.jsx(ConversationPageConversationMessagesMessage.make, {
                                        message: item.fragmentRefs,
                                        conversation: conversation.fragmentRefs
                                      }, item.id);
                                  break;
                              case "ForSalePropertyBroadcast" :
                                  var content$1 = item.content;
                                  var tmp$2;
                                  tmp$2 = content$1 !== undefined && content$1.__typename === "ForSalePropertyV5" ? ({
                                        text: "Click here to view the property page",
                                        href: "/properties/" + content$1.id
                                      }) : undefined;
                                  tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                                        text: "The property was broadcast",
                                        link: tmp$2
                                      });
                                  break;
                              case "RentalNeedBroadcast" :
                                  var content$2 = item.content;
                                  var tmp$3;
                                  tmp$3 = content$2 !== undefined && content$2.__typename === "RentalNeedV5" ? ({
                                        text: "Click here to view the rental need page",
                                        href: "/client_needs/" + content$2.id
                                      }) : undefined;
                                  tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                                        text: "The rental need was broadcast",
                                        link: tmp$3
                                      });
                                  break;
                              case "RentalPropertyBroadcast" :
                                  var content$3 = item.content;
                                  var tmp$4;
                                  tmp$4 = content$3 !== undefined && content$3.__typename === "RentalPropertyV5" ? ({
                                        text: "Click here to view the property page",
                                        href: "/properties/" + content$3.id
                                      }) : undefined;
                                  tmp = JsxRuntime.jsx(ConversationPageConversationMessages$ContextEventMessage, {
                                        text: "The rental property was broadcast",
                                        link: tmp$4
                                      });
                                  break;
                              case "__unselected" :
                                  tmp = null;
                                  break;
                              
                            }
                            return JsxRuntime.jsxs("div", {
                                        children: [
                                          dayForItem !== lastPrintedDay.contents ? (lastPrintedDay.contents = dayForItem, JsxRuntime.jsx("div", {
                                                    children: dayForItem === today ? "Today, " + dayForItem : dayForItem,
                                                    className: "text-center text-gray-600 text-xs mt-4 mb-8"
                                                  })) : null,
                                          tmp
                                        ],
                                        className: "my-4"
                                      }, key);
                          }),
                      forwardRef: Caml_option.some(function (e) {
                            Utils.React.setCurrentRef(messagesListRef, (e == null) ? undefined : Caml_option.some(e));
                          })
                    }),
                JsxRuntime.jsx("span", {
                      ref: Caml_option.some(function (e) {
                            Utils.React.setCurrentRef(messagesReadElementRef, (e == null) ? undefined : Caml_option.some(e));
                          })
                    })
              ]
            });
}

var make = ConversationPageConversationMessages;

exports.MessagesContainer = MessagesContainer;
exports.ConversationFragment = ConversationFragment;
exports.Subscription = Subscription;
exports.ContextEventMessage = ContextEventMessage;
exports.MarkConversationMessagesAsReadV5Mutation = MarkConversationMessagesAsReadV5Mutation;
exports.make = make;
/* subscribe Not a pure module */
